import React, { useEffect } from 'react';
import { Container, Stack, Typography } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import { FormattedMessage, useIntl } from 'react-intl';

export const RedirectPage = () => {
  const { formatMessage } = useIntl();

  useEffect(() => {
    window.location.href = '/api/tenants/redirect';
  }, []);

  return (
    <>
      <Helmet>
        <title>{formatMessage({ id: 'RedirectPage.Title', defaultMessage: 'Redirection' })}</title>
        <meta name="description" content={formatMessage({ id: 'RedirectPage.Description', defaultMessage: 'You are being redirected' })} />
      </Helmet>
      <Container maxWidth='xl'>
        <Stack gap={2} py={4}>
          <Typography variant='h4'>{formatMessage({ id: 'RedirectPage.Message', defaultMessage: 'You are being redirected to our product home page...' })}</Typography>
          <Typography>
            <FormattedMessage
              id='RedirectPage.Instruction'
              defaultMessage={'Please <a>click here</a> if you are not redirected within a few seconds'}
              values={{
                a: chunks => <a href='/api/tenants/redirect'>{chunks}</a>
              }}
            />
          </Typography>
        </Stack>
      </Container>
    </>
  );
};